import PropTypes from "prop-types";
import {Chip, Divider, Grid, Tooltip, Typography} from "@material-ui/core";
import {ReactComponent as IconItaly} from "../../../../../../assets/images/icon-content-italy-24-px.svg";
import {ReactComponent as IconEurope} from "../../../../../../assets/images/icon-content-europe-24-px.svg";
import LanguageIcon from "@material-ui/icons/Language";
import PhoneOutlinedIcon from "@material-ui/icons/PhoneOutlined";
import WifiIcon from "@material-ui/icons/Wifi";
import SmsOutlinedIcon from "@material-ui/icons/SmsOutlined";
import React from "react";
import {trafficType, zoneIcon} from "../MainHelper";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import HelpIcon from "@material-ui/icons/Help";
import Hidden from "@material-ui/core/Hidden";
import {useMainOfferContentStyles} from "./MainOfferContentStyles";
import {PeopleOutlined} from "@material-ui/icons";

const MainOfferContent = (props) => {
    const classes = useMainOfferContentStyles()

    // If there are 4 zones, all should be shown in the same row, when screen fits them
    const getGridDimension = () => {
        if (props.zoneData.length === 4)
            return 3
        if (props.zoneData.length === 2)
            return 6
        return 4
    }

    const getCountryFlag = (countryIcon) => {
        if (countryIcon === zoneIcon.IT) return <IconItaly/>
        if (countryIcon === zoneIcon.EU) return <IconEurope/>
        if (countryIcon === zoneIcon.INT) return <LanguageIcon/>
    }

    const getTrafficIcon = (trafficIcon) => {
        if (trafficIcon === trafficType.VOCE) return (<PhoneOutlinedIcon fontSize={"small"}/>)
        if (trafficIcon === trafficType.DATI) return (<WifiIcon fontSize={"small"}/>)
        if (trafficIcon === trafficType.SMS) return (<SmsOutlinedIcon fontSize={"small"}/>)
    }

    const getZoneTitle = (zone) => {
        return <Box className={classes.zoneBox}>
            {getCountryFlag(zone.zoneIcon)}

            <Box component={"span"}
                 marginLeft={1}>
                <Typography variant={"subtitle2"}
                            component={"span"}>
                    {zone.zone}
                </Typography>
            </Box>

            {zone.tooltipData ? <Tooltip title={zone.tooltipData}
                                         arrow>
                <Box component={"span"}
                     marginLeft={1}>
                    <IconButton color={"primary"} size={"small"}>
                        <HelpIcon color={"primary"}/>
                    </IconButton>
                </Box>
            </Tooltip> : null}
        </Box>
    }

    const plafondChip = (
        <Chip avatar={<PeopleOutlined style={{color: "#b2b2b2"}}/>}
              label={<Typography color={"textSecondary"} variant={"overline"}>CONDIVISO</Typography>}
              variant="outlined"
              size={"small"}
              style={{display: "flex", borderRadius: 3, marginLeft: "5px", color: "#b2b2b2"}}
              color={"default"}/>
    )

    return (
        <>
            <Box marginY={2}>
                {!props.isOpzioni ?
                    <Typography variant={"overline"}
                                color={"textSecondary"}>
                        {props.planName}
                    </Typography>
                    : null}
            </Box>

            <Grid container
                  spacing={2}>
                {props.zoneData ? props.zoneData.map((zone, index) => {
                    return (
                        <Grid item
                              xs={12} sm={6} md={getGridDimension()} lg={getGridDimension()}
                              key={`offer-zone-${zone.zone}`}>
                            {getZoneTitle(zone)}

                            {zone.trafficoCondivisioneListLabel ?
                                <>
                                    <Box marginY={2}>
                                        <Typography variant={"overline"}>
                                            {zone.trafficoCondivisioneListLabel}
                                        </Typography>
                                    </Box>

                                    {zone.trafficoCondivisioneList?.length && zone.trafficoCondivisioneList.map((zoneItem, index) => {
                                        return (
                                            <Box key={`zone-${zone.zone}-zoneItem-${index}`}
                                                 marginBottom={2}
                                                 className={classes.zoneBox}>
                                                {getTrafficIcon(zoneItem.typeIcon)}

                                                <Box component={"span"}
                                                     marginLeft={2}>
                                                    <Grid container>
                                                        <Typography variant={"subtitle2"}>
                                                            {zoneItem.typeDescription}
                                                        </Typography>
                                                        {zoneItem.isPlafondShareCondiviso ? plafondChip : null}
                                                    </Grid>
                                                </Box>
                                            </Box>
                                        )
                                    })}
                                </>
                                : null}

                            <Box marginY={2}>
                                <Typography variant={"overline"}>
                                    {zone.trafficoCondivisioneListLabel ?
                                        zone.trafficoSingolaListLabel :
                                        "Traffico incluso"}
                                </Typography>
                            </Box>

                            {(zone.trafficoSingoloList?.length ? zone.trafficoSingoloList : zone.offertaZoneDescriptionList)?.map((zoneItem, index) => {
                                return (
                                    <Box key={`zone-${zone.zone}-zoneItem-${index}`}
                                         marginBottom={2}
                                         className={classes.zoneBox}>
                                        {getTrafficIcon(zoneItem.typeIcon)}
                                        <Box component={"span"}
                                             marginLeft={2}>
                                            <Grid container>
                                                <Typography variant={"subtitle2"}>
                                                    {zoneItem.typeDescription}
                                                </Typography>
                                                {zoneItem.isPlafondShareCondiviso ? plafondChip : null}
                                            </Grid>
                                        </Box>
                                    </Box>
                                );
                            })}

                            {/*Don't show divider horizontal on last element*/}
                            {index < props.zoneData.length - 1 ? <Hidden smUp>
                                <Box marginY={1}>
                                    <Divider orientation={"horizontal"}
                                             variant={"middle"}/>
                                </Box>
                            </Hidden> : null}
                        </Grid>
                    )
                }) : null}
            </Grid>
        </>
    )
}

MainOfferContent.propTypes = {
    zoneData: PropTypes.array.isRequired,
    planName: PropTypes.string.isRequired,
    isOpzioni: PropTypes.bool,
}

MainOfferContent.defaultProps = {
    isOpzioni: false
}

export default MainOfferContent;
